import * as React from "react";
function SvgDiscClose(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <circle cx={24} cy={24} r={24} />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={6}
        d="M14 14l20 20M34 14L14 34"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgDiscClose);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
